import React from "react";

function QzPrinterContainer() {
  return <div id="qzPrintContainer" />;
}

export default QzPrinterContainer;
